import { IQueryStringNavLinks } from "../../interfaces-and-types";
import { View } from "./View";

export const ReportsBalance = () => {
  const queryStringTabs: IQueryStringNavLinks = {
    query: "",
    options: [
      {
        key: "Balance",
        value: "",
      },
    ],
  };

  return <View queryStringTabs={queryStringTabs} />;
};
